module.exports = __webpack_public_path__ + "6ce7c940c08bce70be216471136b4f66.glb";